import React, { Component } from 'react';
import { ButtonToolbar, Button, Checkbox, Row } from 'react-bootstrap';
import { Map, TileLayer, Marker, Pane, Tooltip, Polyline } from 'react-leaflet';
import { Modal } from 'react-bootstrap';
import { stopIcon, stopIconSelected } from '../../../components/leaflet/StopIcon';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';

export class PathsInMap extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedStops: [],
            showAllpaths: true,
            showAllStops: false,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
            exitMap: false
        }
    }

    getBounds(stops) {
        let bounds = [];
        if (0 !== stops.length) {
            stops.forEach((stop) => {
                let latlng = [stop.latitude, stop.longitude];

                bounds.push(latlng);
            });
        }
        else {
            bounds = [{ lat: -90, lng: -180 }, { lat: 90, lng: 180 }];
        }

        return bounds;
    }

    onStopClick(stopId) {
        const { stops, temporaryTrips } = this.props;
        const { selectedStops } = this.state;

        let remove = undefined;
        let stop = stops.find(s => s.id === stopId);
        let stopIndex = stops.indexOf(stop);
        this.props.giveValueToSelectedStop(stopIndex, []);

        if (selectedStops.length > 0) {
            let indexSS = selectedStops.indexOf(stop);

            if (indexSS > -1) {
                selectedStops.splice(indexSS, 1);
                remove = stop;
            } else {
                selectedStops.push(stop);
            }

            temporaryTrips(selectedStops, remove);
        } else {
            selectedStops.push(stop);
        }

        this.setState({
            selectedStops
        });
    }

    handleCheckBoxChange() {
        let aux = this.state.showAllpaths;

        this.setState({
            showAllpaths: aux ? false : true
        });
    }

    onCreate() {
        let aux = this.state.showAllStops;

        this.setState({
            showAllStops: aux ? false : true
        });
    }

    onCleanClick() {
        this.setState({
            selectedStops: []
        },
            this.props.temporaryTrips([], undefined),
            this.props.giveValueToSelectedStop(-1, [])
        );
    }

    onSave() {
        const { selectedStops } = this.state;

        if (selectedStops.length > 0) {
            this.props.onCreateClick(true);
            this.props.giveValueToSelectedStop(0, selectedStops);

            this.setState({
                selectedStops: []
            });
        } else {
            this.setState({
                showErrorModal: true,
                alertTitle: "Aviso",
                alertMessage: "É necessário selecionar paragens.",
                alertStyle: "warning",
                icon: 'alert',
            });
        }
    }

    onDialogExit = (isToExecute) => {
        if (isToExecute) {
            if (!this.state.exitMap) {
                this.setState({
                    showDeleteModal: false
                },
                    this.props.changePathFormShowValue(false)
                );
            } else {
                this.setState({
                    selectedStops: [],
                    showDeleteModal: false
                },
                    this.props.onExit
                );
            }
        } else {
            this.setState({
                showDeleteModal: false
            });
        }
    }

    onExit() {
        if (this.props.mapSelectedStops.length > 0) {
            this.setState({
                alertTitle: "Aviso",
                alertMessage: "Ao sair vai perder as alterações feitas. Pretende sair?",
                alertStyle: 'warning',
                icon: 'alert',
                showDeleteModal: true,
                justExit: true,
                exitMap: true,
                selectedStops: []
            });
        } else {
            this.setState({
                selectedStops: []
            },
                this.props.onExit()
            );
        }
    }

    clearError() {
        this.setState({
            showErrorModal: false,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined
        });
    }

    renderTrips(trips, showAllpaths) {
        if (0 === trips.length || !showAllpaths) {
            return null;
        }

        return (
            <div>
                {
                    trips.map((trip, idx) =>
                        <div key={`trip-polyLine-${idx}`}>
                            <Polyline positions={[trip.origin, trip.destination]} color={trip.lineColor} />
                        </div>
                    )
                }
            </div>
        );
    }

    render() {
        const { show } = this.props;

        if(!show) {
            return null;
        }

        const { stops, trips, tempTrips } = this.props;
        const { hasShapes, isEditable } = this.props;
        const { showAllpaths } = this.state;
        const { showAllStops } = this.state;

        const tripsOriginStops = trips.map(trip => trip.originId);
        const tripsDestinationStops = trips.map(trip => trip.destinationId);
        
        let stopsToRender = [];
        if (!hasShapes) {
            stopsToRender = stops.filter(stop => tripsOriginStops.includes(stop.id) || tripsDestinationStops.includes(stop.id));
        }
        else {
            stopsToRender = stops
        }

        return (
            <div>
                <Modal show={show} className="map-modal" >
                    <Modal.Header>
                        <Modal.Title>
                            Rede no Mapa
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Map className="map-container" bounds={this.getBounds(stopsToRender)}>
                            <TileLayer
                                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <Pane>
                                {this.renderTrips(trips, showAllpaths)}
                                {
                                    tempTrips.length > 0 ?
                                        tempTrips.map((trip, idx) =>
                                            <div key={`polyLine-${idx}`}>
                                                <Polyline positions={[trip.origin, trip.destination]} color={trip.lineColor} />
                                            </div>
                                        )
                                        : null
                                }
                            </Pane>
                            <Pane>
                                {
                                    stopsToRender.length > 0 ?
                                        stopsToRender.map((stop, idx) =>
                                            <Marker
                                                key={stop.id}
                                                position={stop.position}
                                                icon={stop.selected ? stopIconSelected : stopIcon}
                                                onclick={(e) => this.onStopClick(stop.id, e)}
                                            >
                                                <Tooltip>
                                                    <span>
                                                        {stop.name} ({stop.code})
                                                    </span>
                                                </Tooltip>
                                            </Marker>
                                        )
                                        : null
                                }
                                {
                                    showAllStops ? 
                                        stops.length > 0 ?
                                            stops.map((stop, idx) =>
                                                <Marker
                                                    key={stop.id}
                                                    position={stop.position}
                                                    icon={stop.selected ? stopIconSelected : stopIcon}
                                                    onclick={(e) => this.onStopClick(stop.id, e)}
                                                >
                                                    <Tooltip>
                                                        <span>
                                                            {stop.name} ({stop.code})
                                                        </span>
                                                    </Tooltip>
                                                </Marker>
                                            )
                                            : null
                                        : null
                                }

                            </Pane>
                        </Map>
                        <Row className="stopsMapButtonsFooter">
                            {!isEditable ? (
                                <ButtonToolbar className="padding-right-15 float-right btns-paths-in-map-small-screens">
                                    <Button onClick={() => this.onExit()}>FECHAR</Button>
                                </ButtonToolbar>
                            ) : (
                                <div>
                                    <Checkbox 
                                        className="pull-left checkbox-paths-in-map" 
                                        checked={showAllpaths} 
                                        onChange={() => this.handleCheckBoxChange()}
                                    >
                                        MOSTRAR PERCURSOS
                                    </Checkbox>
                                    <ButtonToolbar className="padding-right-15 float-right btns-paths-in-map-small-screens">
                                        <Button onClick={() => showAllStops ? this.onSave() : this.onCreate()}>
                                            {showAllStops ? "GUARDAR PERCURSO" : "CRIAR PERCURSO"}
                                        </Button>
                                        <Button onClick={() => this.onCleanClick()}>LIMPAR</Button>
                                        <Button onClick={() => this.onExit()}>FECHAR</Button>
                                    </ButtonToolbar>
                                </div>
                            )}
                        </Row>
                    </Modal.Body>
                </Modal>

                <HandleDialog show={this.state.showDeleteModal}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    onExit={(a) => this.onDialogExit(a)} />
                <HandleMessage title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    show={this.state.showErrorModal}
                    onHide={() => this.clearError()} />
            </div>
        )
    }
}
